import {
  CheckoutShippingMethodPageHitV2,
  SelectDeliveryMethodCheckoutShippingMethodClickV2,
} from '@inditex/resellanl-ianalytics-events';
import { buildEvent } from '../helpers/build-event';
import { normalizeUniverse } from '../helpers/normalize-universe';

export const CHECKOUT_SHIPPING_METHOD_PAGE_HIT = ({ data }: { data?: unknown }) => {
  const payload = data as {
    cartId?: string | number | null;
    deliveryMethod?: string | null;
    universe?: string | null;
    travelMode?: boolean | null;
    storeMode?: {
      geoStoreId?: number | null;
      physicalStoreId?: number | null;
    } | null;
  };

  return buildEvent({
    Event: CheckoutShippingMethodPageHitV2,
    payload: {
      cartId: payload?.cartId != null ? String(payload.cartId) : '',
      deliveryMethod: payload?.deliveryMethod ?? '',
      universe: payload?.universe ? normalizeUniverse(payload.universe) : null,
      travelMode: payload?.travelMode ?? null,
      storeMode: payload?.storeMode ?? null,
    },
  });
};

export const SELECT_DELIVERY_METHOD_CHECKOUT_SHIPPING_METHOD_CLICK = ({ data }: { data?: unknown }) => {
  const payload = data as {
    cartId?: string | number | null;
    deliveryMethod?: string | null;
    universe?: string | null;
    travelMode?: boolean | null;
    storeMode?: unknown;
  };

  const event = buildEvent({
    Event: SelectDeliveryMethodCheckoutShippingMethodClickV2,
    payload: {
      cartId: payload?.cartId != null ? String(payload.cartId) : '',
      deliveryMethod: payload?.deliveryMethod ?? '',
      universe: payload?.universe ? normalizeUniverse(payload.universe) : null,
      travelMode: payload?.travelMode ?? null,
      storeMode: payload?.storeMode ?? null,
    },
  });

  return event;
};
